export default "__VITE_ASSET__YD5hC9I2__"